import Cookies from 'js-cookie';

export function logOut(){
    localStorage.removeItem('loginUserId');
    localStorage.removeItem('loginUserName');
    localStorage.removeItem('loginUserImage');
    Cookies.remove('userId');
}